var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"az-loading"},[_c('v-overlay',{attrs:{"value":_vm.isLoading,"z-index":"1000"}},[_c('v-progress-circular',{attrs:{"indeterminate":"","size":100}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }